"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableMask = void 0;
var tslib_1 = require("tslib");
var fast_xml_parser_1 = require("fast-xml-parser");
var drawable_1 = require("./drawable");
var parser = new fast_xml_parser_1.XMLParser({
    attributeNamePrefix: '',
    ignoreAttributes: false,
    parseAttributeValue: true,
    trimValues: true,
    // all groups should be parsed as arrays even if there is only one child
    isArray: function (name) {
        if (name === 'g') {
            return true;
        }
        return false;
    }
});
var CollectionModelDrawableMask = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableMask, _super);
    function CollectionModelDrawableMask() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tag = 'mask';
        _this.Mutator = new drawable_1.CollectionModelDrawableMutator(_this);
        _this.parsedSvg = null;
        _this.svgStringInFlight = false;
        return _this;
    }
    CollectionModelDrawableMask.state = function (id) {
        return {
            id: id,
            tag: 'mask',
            x: 0,
            y: 0
        };
    };
    CollectionModelDrawableMask.prototype.fetchSvgMask = function (fetchingCallBack) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var svgString;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // If the string already exists or is in flight, don't fetch it again
                        if (this.parsedSvg) {
                            return [2 /*return*/];
                        }
                        if (this.svgStringInFlight) {
                            return [2 /*return*/];
                        }
                        this.svgStringInFlight = true;
                        return [4 /*yield*/, fetchingCallBack()];
                    case 1:
                        svgString = _a.sent();
                        this.parsedSvg = parser.parse(svgString);
                        this.svgStringInFlight = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CollectionModelDrawableMask.isMask = function (t) {
        return t.tag === 'mask';
    };
    return CollectionModelDrawableMask;
}(drawable_1.CollectionModelDrawable));
exports.CollectionModelDrawableMask = CollectionModelDrawableMask;
//# sourceMappingURL=mask.drawable.js.map